import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=5bd9330c&scoped=true&"
import script from "./MessagesTable.vue?vue&type=script&lang=js&"
export * from "./MessagesTable.vue?vue&type=script&lang=js&"
import style0 from "./MessagesTable.vue?vue&type=style&index=0&id=5bd9330c&lang=scss&scoped=true&"
import style1 from "./MessagesTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9330c",
  null
  
)

export default component.exports